module.exports = __webpack_public_path__ + "static/media/pdf-logo.322127e3.png";